import React, { useState } from "react";
import "./orderTable.css";
import styled from "@emotion/styled";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import ReimburseModal from "../modals/Distributor/reimburseModal";

export const TableContainer = styled("div")(
  {
    background: "#ffffff",
    border: "1px solid #e7e5ff",
    borderRadius: "15px",

    maxWidth: "50rem",
    height: "25rem",
    overflowY: "auto",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

export const TableFooter = styled("div")(
  {
    background: "#2AD3E7",
    border: "1px solid #e7e5ff",
    borderBottomLeftRadius: " 15px",
    borderBottomRightRadius: "15px",
    maxWidth: "45rem",
    height: "3rem",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

const DistributorOrdersDetailsTable = ({ maxWidth = "70rem", orders = [] }) => {
  const navigate = useNavigate();
  const [onReimburseShow, setOnReimburseShow] = useState(false);
  return (
    <div className="mx-2">
      <TableContainer maxWidth={maxWidth}>
        <table className="main-table">
          <thead>
            <tr className="table-rows">
              <th className="table-heads2" width={"2%"}>
                #
              </th>
              <th className="table-heads2" width={"4%"}>
                Order ID
              </th>
              <th className="table-heads2" width={"14%"}>
                Order Date
              </th>
              <th className="table-heads2" width={"10%"}>
                Doctor name
              </th>
              <th className="table-heads2" width={"11%"}>
                Pharmacy Name
              </th>
              <th className="table-heads2" width={"8%"}>
                Order Value
              </th>
              <th className="table-heads2" width={"12%"}>
                Order Status
              </th>
              <th className="table-heads2" width={"6%"}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody style={{ position: "relative" }}>
            {orders.length > 0 ? (
              <>
                {orders.map((odr, index) => (
                  <tr className="table-rows2">
                    <td className="table-each-row-data">{index + 1}</td>
                    <td
                      className="table-each-row-data cursor_pointer"
                      // onClick={() => selectOrder(odr)}
                    >
                      {odr?.order_id ? odr?.order_id : "--"}
                    </td>
                    <td className="table-each-row-data">
                      {odr?.createdAt
                        ? moment(odr?.createdAt).format("DD MMM YYYY, HH:mm A")
                        : "--"}
                    </td>
                    <td className="table-each-row-data">
                      {odr?.doctor?.name ? odr?.doctor?.name : "--"}
                    </td>
                    <td className="table-each-row-data">
                      {odr?.pharmacy_id
                        ? odr?.pharmacy?.pharmacy_name
                        : odr?.doctor?.pharmacy_type == "attach"
                        ? odr?.doctor?.doctorAttachPharmacy?.pharmacy
                            ?.pharmacy_name
                        : odr?.doctor?.pharmacy_type == "self"
                        ? odr?.doctor?.doctorSelfPharmacy?.pharmacy_name
                        : "--"}
                    </td>
                    <td className="table-each-row-data">
                      {" "}
                      {odr?.total ? `₹ ${odr?.total}` : "--"}
                    </td>
                    <td className="table-each-row-data">
                      <span
                        className={`${
                          orderStatus?.find((e) => e?.status == odr?.status)
                            ?.color
                        }`}
                      >
                        {orderStatus?.find((e) => e?.status == odr?.status)
                          ?.value
                          ? orderStatus?.find((e) => e?.status == odr?.status)
                              ?.value
                          : "--"}
                      </span>
                    </td>
                    <td className="table-each-row-data cursor_pointer">
                      <span
                        className="color_2ad3e7 fw_700 mx-2"
                        onClick={() => {
                          navigate("/distributors/onboarded/view/order-view", {
                            state: {
                              ...odr,
                            },
                          });
                        }}
                      >
                        VIEW
                      </span>
                      <span
                        className="Medium_Purple  fw_700 mx-2"
                        onClick={() => setOnReimburseShow(true)}
                      >
                        REIMBURSE
                      </span>
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td
                  colSpan="1"
                  className="text-center distri-no-data-container fs_16"
                >
                  <span>~ No Data Found ~</span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </TableContainer>
      <ReimburseModal
        show={onReimburseShow}
        handleClose={() => setOnReimburseShow(false)}
      />
    </div>
  );
};

export default DistributorOrdersDetailsTable;

export const orderStatus = [
  { status: "acknowledged", value: "Acknowledged", color: "ack_status " },
  {
    status: "partially_acknowledged",
    value: "Partially Acknowledged",
    color: "color_2ad3e7 ",
  },
  { status: "fully_invoiced", value: "Invoiced", color: "text_green " },
  {
    status: "partially_invoice",
    value: "Partial Invoiced",
    color: "Medium_Purple",
  },
  { status: "pending", value: "Approval Pending", color: "Medium_Purple" },
  { status: "expired", value: "Expired", color: "text-danger" },
  { status: "cancelled", value: "Cancelled", color: "text-danger" },
  { status: "approval_failed", value: "Approval Failed", color: "text-danger" },
  { status: "approved", value: "Approved", color: "color_2ad3e7" },
  { status: "delivered", value: "Delivered", color: "text_green" },
  {
    status: "out_for_delivery",
    value: "Out For Delivery",
    color: "text-danger",
  },
  { status: "rejected", value: "Rejected", color: "text-danger" },
];
